import { createAction, props } from '@ngrx/store';

export const getQBFields = createAction('[Query Builder] Get Query Builder Fields', props<{ apiConstants: any }>());
export const setQBFields = createAction('[Query Builder] set Query Builder Fields', props<{ qbFields: any }>());
export const getQBQueries = createAction(
  '[Query Builder] Get Query Builder Queries',
  props<{ apiConstants: any; params: any }>()
);
export const setQBQueries = createAction('[Query Builder] Set Query Builder Queries', props<{ qbQueries: any }>());
export const saveQBQueries = createAction(
  '[Query Builder] Save Query Builder Queries',
  props<{ apiConstants: any; queryObject: any }>()
);
export const setQBProperties = createAction('[Query Builder] Set QB Properties', props<{ qbProperties: any }>());
export const getQBProperties = createAction('[Query Builder] Get QB Properties', props<{ qbProperties: any }>());
export const getAllQueries = createAction('[Query Builder] Get All Queries', props<{ apiConstants: any }>());
export const setAllQueries = createAction('[Query Builder] Set All Queries', props<{ allQueries: any }>());
